import { render, staticRenderFns } from "./DetailedProject.vue?vue&type=template&id=99f5b7b8&scoped=true&"
import script from "./DetailedProject.vue?vue&type=script&lang=js&"
export * from "./DetailedProject.vue?vue&type=script&lang=js&"
import style0 from "./DetailedProject.vue?vue&type=style&index=0&id=99f5b7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f5b7b8",
  null
  
)

export default component.exports